var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowListDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.30775 10.8173C4.80258 10.8173 4.375 10.6423 4.025 10.2923C3.675 9.94225 3.5 9.51467 3.5 9.0095V5.30775C3.5 4.80258 3.675 4.375 4.025 4.025C4.375 3.675 4.80258 3.5 5.30775 3.5H18.6923C19.1974 3.5 19.625 3.675 19.975 4.025C20.325 4.375 20.5 4.80258 20.5 5.30775V9.0095C20.5 9.51467 20.325 9.94225 19.975 10.2923C19.625 10.6423 19.1974 10.8173 18.6923 10.8173H5.30775ZM5.30775 20.5C4.80258 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V15C3.5 14.4948 3.675 14.0673 4.025 13.7172C4.375 13.3673 4.80258 13.1923 5.30775 13.1923H18.6923C19.1974 13.1923 19.625 13.3673 19.975 13.7172C20.325 14.0673 20.5 14.4948 20.5 15V18.6923C20.5 19.1974 20.325 19.625 19.975 19.975C19.625 20.325 19.1974 20.5 18.6923 20.5H5.30775Z",
    fill: "#6D7A9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowListDefault);
export default __webpack_public_path__ + "static/media/show_list_default.06e6e55e97f99e25fddab6f2cd4cac0f.svg";
export { ForwardRef as ReactComponent };